export default __webpack_public_path__ + "static/project-29aa04708346b1fccf245b87dbe1062c.jpeg";